import { DeprecatedSelect } from "@octopusdeploy/design-system-octopus-components";
import { withBoundField } from "./BoundField";
export const BoundSelect = withBoundField(DeprecatedSelect);
